import { render, staticRenderFns } from "./InventoriesRefillsTitle.vue?vue&type=template&id=22da0d26&scoped=true"
import script from "./InventoriesRefillsTitle.vue?vue&type=script&lang=js"
export * from "./InventoriesRefillsTitle.vue?vue&type=script&lang=js"
import style0 from "./InventoriesRefillsTitle.vue?vue&type=style&index=0&id=22da0d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22da0d26",
  null
  
)

export default component.exports